export const productName = 'ENVIRONMENTAL MANAGEMENT TEACHER READY';
export const productShortName = 'Environmental Management Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/qUJQ2vDJM3yjf1d7NzNFb8/mockup_8.03.01_p._m..png';

export const checkoutUrl = 'https://environmental-management-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Environmental Management Fundamentals',
  'Volume 2 — Ecosystems, Biodiversity & Natural Resources',
  'Volume 3 — Pollution Prevention & Environmental Quality',
  'Volume 4 — Environmental Impact Assessment & Risk Management',
  'Volume 5 — Waste Management & Circular Economy',
  'Volume 6 — Environmental Management Systems & Sustainable Organizations',
  'Volume 7 — Climate Change, Energy & Environmental Challenges',
  'Volume 8 — Sustainable Development & Environmental Solutions',
  'Volume 9 — Teaching Environmental Management',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — 100 Environmental Problems & Decision-Making Scenarios',
  'Bonus 3 — 100 Case Studies & Real-World Scenarios',
  'Bonus 4 — 50 Environmental Management Classroom Projects',
  "Bonus 5 — Environmental Management Teacher's Concept & Terminology Guide",
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex environmental concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see environmental management's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
